import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "gatsby"

const Header = (props) => { 
  const opcions = props.lang === 'ca' ? ['Qui soc', 'Vida sentida', 'Llibre', 'Contacte'] : ['Quién soy', 'Vida sentida', 'Libro', 'Contacto'];
    
  return (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="content">
            <div className="inner">
                <h1>Gemma Farràs</h1>
                <h2>Vida Sentida</h2>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('intro')}}>{opcions[0]}</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('work')}}>{opcions[1]}</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>{opcions[2]}</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('contact')}}>{opcions[3]}</a></li>
            </ul>
        </nav>
    </header>
  )
}

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
